"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Functions {
    static IsPowerOf2(num) {
        return num != 0 && (num & (num - 1)) == 0;
    }
}
exports.Functions = Functions;
